import React, {FunctionComponent, useState} from 'react';

import {Alert, ButtonCountdown} from 'components';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader} from '@cfa/react-components';
import {AsyncStatus} from 'enums';
import { UpdatePageModel } from '../UpdatePageModel';

interface IRevertDraftModalProps {
    model: UpdatePageModel,
    onClose: () => void,
    show: boolean,
}

export const RevertDraftModal: FunctionComponent<IRevertDraftModalProps> = function(props) {
    const { model, show, onClose } = props;
    const [status, setStatus] = useState(AsyncStatus.Initial);
    const [err, setErr] = useState('');

    function tryHide() {
        // Prevent closing the modal if an API call is in progress.
        if (status !== AsyncStatus.Loading) {
            onClose();
        }
    }

    function onConfirm() {
        if (status === AsyncStatus.Loading) return;

        setStatus(AsyncStatus.Loading);
        model.revertToDraft()
            .then(onClose)
            .catch((err) => {
                setStatus(AsyncStatus.Error);
                setErr(model.apiCallError);
            });
    }

    return (
        <Modal show={show} onClose={tryHide}>
            <ModalHeader>
                Revert to Draft
            </ModalHeader>
            <ModalBody>
                <p>
                    Are you sure you want to revert "<b>{model.update.name}</b>" to a draft? This will allow you to edit it,
                    but it will need to be re-approved before it can be deployed.
                </p>
                {status === AsyncStatus.Error && (
                    <Alert type="danger">
                        We're sorry, an error has occurred: {err}
                    </Alert>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    variant="outlined"
                    onClick={tryHide}
                    disabled={status === AsyncStatus.Loading}
                >
                    Cancel
                </Button>
                <ButtonCountdown
                    style={{marginLeft: "10px"}}
                    onClick={onConfirm}
                    loading={status === AsyncStatus.Loading}
                    disabled={status === AsyncStatus.Success}
                >
                    {status === AsyncStatus.Loading && 'Reverting to draft...'}
                    {status !== AsyncStatus.Loading && 'Revert to draft'}
                </ButtonCountdown>
            </ModalFooter>
        </Modal>
    );
}